<template>
    <div class="cst-survey-progress-bar">
        <div class="cst-survey-progress-bar-bar" v-bind:style="{ transform: 'translateX(' +  currentProgressPct + '%)' }"></div>
    </div>
</template>

<script>
    export default {
      props: [ 'currentProgressPct' ]
    }
</script>

<style lang="less" scoped>
    @import '../_theme';

    .cst-survey-progress-bar {
        height: 0.4em;
        background-color: @main-headline-color;
        overflow: hidden;
    }

    .cst-survey-progress-bar-bar {
        transition: all 250ms linear;
        background-color: @progressbar-background;
        height: 0.6em;
    }
</style>


// WEBPACK FOOTER //
// src/components/AppProgressBar.vue